import type Store from '@ember-data/store';
import { action } from '@ember/object';
import Service from '@ember/service';
import { service } from '@ember/service';
import { tracked } from 'tracked-built-ins';

export default class DownloadService extends Service {
  @service declare store: Store;

  async order(orderId: string): Promise<void> {
    const order = this.store.peekRecord('order', orderId);
    if (order?.status === 'created') {
      order.status = 'ordered';
      await order.save();
    }
    const url = `/api/orders/${orderId}/render`;
    const shortName = order.supplier.pdf_short_name;
    const name = order.supplier.name.slice(0, 15);
    const date = new Date(order.delivery_date).toISOString().slice(0, 10);

    const fileName = `${shortName ? shortName : name}_${date}.pdf`;
    const toReturn = this.download(url, fileName);
    return toReturn;
  }
  async order_old(orderId: string): Promise<void> {
    const order = this.store.peekRecord('order', orderId);
    if (order?.status === 'created') {
      order.status = 'ordered';
      await order.save();
    }
    const url = `/api/orders/${orderId}/render_old`;
    const shortName = order.supplier.pdf_short_name;
    const name = order.supplier.name.slice(0, 15);
    const date = new Date(order.delivery_date).toISOString().slice(0, 10);

    const fileName = `${shortName ? shortName : name}_${date}.pdf`;
    const toReturn = this.download(url, fileName);
    return toReturn;
  }

  @tracked isDownloading = false;
  @action
  async download(url: string, fileName: string): Promise<void> {
    this.isDownloading = true;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    } finally {
      this.isDownloading = false;
    }
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:download')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('download') declare altName: DownloadService;`.
declare module '@ember/service' {
  interface Registry {
    download: DownloadService;
  }
}
